import React, { useState, useContext, useEffect, useLayoutEffect } from 'react';
import { PageContext } from 'lib/PageProvider';
import { UserMeterGridStateful } from "components/admin/Users/UserMeterGridStateful"
import { mutateUrls } from "lib/useGenericSWR";
import { useSWRConfig } from "swr";
import { EnsureUser } from 'components/auth/EnsureUser';
import { UcToolbar } from 'components/common/UcToolbar';
import { UserMeterOutageDialog } from './UserMeterOutageDialog';
import { MeterFormDialog } from '../Customers/MeterFormDialog';

export const UserMeterList = (props) => {
    const { userId } = props;
    const [selectedItem, setSelectedItem] = useState(null);
    const [pageState, pageDispatch] = useContext(PageContext);
    const [generalSearch, setGeneralSearch] = useState('');
    const [sendOutageDialog, setSendOutageDialog] = useState({ open: false });
    const [editDialog, setEditDialog] = useState({ open: false });

    const [reMutateUrls, setReMutateUrls] = useState(false);
    const swrConfig = useSWRConfig();

    const closeHandler = () => {
        setEditDialog({ open: false, itemToEdit: editDialog.dataItem });
    }

    const saveHandler = () => {
        closeHandler();
        // Also, remutate
        setReMutateUrls(true);
    }

    const closeOutageHandler = () => {
        sendOutageDialog({ open: false, itemToEdit: sendOutageDialog.dataItem });
    }

    const saveOutageHandler = () => {
        closeOutageHandler();
        // Also, remutate
        setReMutateUrls(true);
    }

    const openOutageDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }
        if (!dataItem.formIteration) {
            dataItem.formIteration = "sendOutage" + dataItem.userId;
        }
        setSendOutageDialog({ open: true, itemToEdit: dataItem });
    }

    const sendOutageItem = (selectedItem) => {
        openOutageDialog(selectedItem);
    }

    const openDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }
        if (!dataItem.formIteration) {
            dataItem.formIteration = "edit" + dataItem.accountId;
        }
        setEditDialog({ open: true, itemToEdit: dataItem });
    }

    const editItem = (selectedItem) => {
        openDialog(selectedItem);
    }

    useLayoutEffect(() => {
        if (reMutateUrls) {
            mutateUrls(swrConfig);
            setReMutateUrls(false);
        }
    }, [reMutateUrls, swrConfig]);

    useEffect(() => {
        pageDispatch({
            header: "Meters",
        });
    }, [pageState.header, selectedItem, pageDispatch]);

    const actions = [];

    console.log("UserMeterListPage - Loaded");
    return (
        <EnsureUser permissions={["UserAccount:Read"]}>
            <div className="UserMeterList">
                <UcToolbar
                    hasGeneralSearch={true}
                    onGeneralSearchChange={(value) => {
                        setGeneralSearch(value);
                    }}
                    actions={actions}>
                </UcToolbar>
                <UserMeterOutageDialog
                    open={sendOutageDialog.open}
                    itemToEdit={sendOutageDialog.itemToEdit}
                    onCancel={closeOutageHandler}
                    onSave={saveOutageHandler}
                />
                <MeterFormDialog        
                    accountId={selectedItem?.accountId}
                    open={editDialog.open}
                    itemToEdit={editDialog.itemToEdit}
                    onCancel={closeHandler}
                    onSave={saveHandler}
                />
                {!reMutateUrls &&
                    <UserMeterGridStateful
                        generalSearch={generalSearch}
                        onSendOutage={sendOutageItem}
                        onEditItem={editItem}
                        userId={userId}
                        onSelected={(selectedSearchItem) => {
                            setSelectedItem({ ...selectedSearchItem });
                        }} />
                }
            </div>
        </EnsureUser>
    );
};